import { Cohort } from '@dtx-company/true-common/src/types/cohorts'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { useCohort } from './useCohort'

export type LimitCopy = 'Unlimited' | `${number}`

export interface LimitsCopy {
  codeLimit: LimitCopy
  pageLimit: LimitCopy
}

function getKeyForPlanType(planType: PlanType): Exclude<keyof Cohort, 'name'> {
  switch (planType) {
    case PlanType.FREE:
      return 'free'
    case PlanType.PRO:
      return 'pro'
    case PlanType.PRO_PLUS_ORG:
      return 'proPlus'
    case PlanType.PRO_FLEX:
      return 'proFlex'
    case PlanType.PILOT:
      return 'pilot'
    case PlanType.ENTERPRISE:
      return 'enterprise'
  }
}

export function useCohortLimits(planType: PlanType): LimitsCopy {
  const cohort = useCohort()

  const key = getKeyForPlanType(planType)
  const limits = cohort[key]

  const codeLimit: LimitCopy = limits.codeLimit === Infinity ? 'Unlimited' : `${limits.codeLimit}`
  const pageLimit: LimitCopy = limits.pageLimit === Infinity ? 'Unlimited' : `${limits.pageLimit}`

  return {
    codeLimit,
    pageLimit
  }
}

export function useCohortLimitsByPlan(): Record<PlanType, LimitsCopy> {
  const freeLimits = useCohortLimits(PlanType.FREE)
  const proLimits = useCohortLimits(PlanType.PRO)
  const proPlusOrgLimits = useCohortLimits(PlanType.PRO_PLUS_ORG)
  const proFlexLimits = useCohortLimits(PlanType.PRO_FLEX)
  const pilotLimits = useCohortLimits(PlanType.PILOT)
  const enterpriseLimits = useCohortLimits(PlanType.ENTERPRISE)

  return {
    [PlanType.FREE]: freeLimits,
    [PlanType.PRO]: proLimits,
    [PlanType.PRO_PLUS_ORG]: proPlusOrgLimits,
    [PlanType.PRO_FLEX]: proFlexLimits,
    [PlanType.PILOT]: pilotLimits,
    [PlanType.ENTERPRISE]: enterpriseLimits
  }
}
